import Layer from './Layer';

// mapbox のスタイルで定義されている traffic
export default class MapboxTraffics extends Layer {
    constructor() {
        const id = 'mapbox-traffics';
        const layers = {};
        const paintOptions = {};

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            {
                id: 'mapbox-traffics',
                layers: [
                    'building-outline',
                    'bridge-simple',
                    'bridge-case-simple',
                    'road-simple',
                    'tunnel-simple',
                    'bridge-rail',
                    'road-rail',
                    'aeroway-line',
                    'aeroway-polygon',
                ],
                isShow: true
            },
        ];
        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    async add() {
        // mapbox のスタイルで定義してあるレイヤーは visibility を変更するだけ。
        this._elements
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', 'visible')
                );
            });
    }

    remove() {
        // mapbox のスタイルで定義してあるレイヤーは visibility を変更するだけ。
        this._elements
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', 'none')
                );
            });
    }
};


